module.exports = __webpack_public_path__ + "img/game-of-khans.9e4da00.jpg";